import React from "react";

/**
 * Custom Hook to manage the automatic focus on the search bar
 * @param {string} searchValue - The search value that triggers the focus
 */
const useSearchInputFocus = searchValue => {
	React.useEffect(() => {
		const findSearchInput = () => {
			const searchContainer = document.querySelector(
				".wz-ui-input.wz-ui-input-icon.wz-search-input"
			);
			return (
				searchContainer?.querySelector("input") ||
				document.querySelector(".wz-ui-input input")
			);
		};

		const timer = setTimeout(() => {
			const searchInput = findSearchInput();
			if (searchInput && document.activeElement !== searchInput) {
				searchInput.focus();
			}
		}, 100);

		return () => clearTimeout(timer);
	}, []);
};

export default useSearchInputFocus;
